export default {
    actions: {
        type: Array,
        default: undefined
    }, 
    animation: {
        type: [Boolean, Object],
        default: undefined
    }, 
    appendTo: {
        type: [Object, String],
        default: undefined
    }, 
    autoFocus: {
        type: Boolean,
        default: undefined
    }, 
    content: {
        type: [String, Object],
        default: undefined
    }, 
    draggable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    iframe: {
        type: Boolean,
        default: undefined
    }, 
    height: {
        type: [Number, String],
        default: undefined
    }, 
    maxHeight: {
        type: Number,
        default: undefined
    }, 
    maxWidth: {
        type: Number,
        default: undefined
    }, 
    minHeight: {
        type: Number,
        default: undefined
    }, 
    minWidth: {
        type: Number,
        default: undefined
    }, 
    modal: {
        type: [Boolean, Object],
        default: undefined
    }, 
    pinned: {
        type: Boolean,
        default: undefined
    }, 
    position: Object, 
    resizable: {
        type: Boolean,
        default: undefined
    }, 
    scrollable: {
        type: Boolean,
        default: undefined
    }, 
    title: {
        type: [String, Boolean, Object],
        default: undefined
    }, 
    visible: {
        type: Boolean,
        default: undefined
    }, 
    width: {
        type: [Number, String],
        default: undefined
    }, 
    size: {
        type: String,
        default: undefined
    }, 

    // Events
    activate: Function, 
    close: Function, 
    deactivate: Function, 
    dragend: Function, 
    dragstart: Function, 
    error: Function, 
    maximize: Function, 
    minimize: Function, 
    open: Function, 
    refresh: Function, 
    resize: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/WindowProps.js